import { useState, useEffect } from "react";
import axios from "axios";

const baseUrl = "https://us-central1-prenotam.cloudfunctions.net/addRichiestaAbbonamentoNewWithEmail";


export const UseCreate = (postData, callback) => {
    console.log(postData);
    axios.post(baseUrl, {
        nometitolare : postData.nomeTitolare,
        cognometitolare : postData.cognomeTitolare,
        cittaresidenzatitolare : postData.cittaResidenzaTitolare,
        indirizzoresidenzatitolare : postData.indirizzoResidenzaTitolare,
        civicoresidenzatitolare : postData.civicoResidenzaTitolare,
        capresidenzatitolare : postData.capResidenzaTitolare,
        emailtitolare : postData.emailTitolare,
        mobiletitolare : postData.mobileTitolare,
        ufficiotitolare : postData.ufficioTitolare,
        statustitolare : postData.statusTitolare,
        gradoqualificatitolare : postData.gradoQualificaTitolare,
        forzaarmatatitolare : postData.forzaArmataTitolare,
        sedetitolare : postData.sedeTitolare,
        cmdtitolare : postData.cmdTitolare,
        nomeconiugedefunto : postData.nomeConiugeDefunto,
        cognomeconiugedefunto : postData.cognomeConiugeDefunto,
        tipodocumentotitolare : postData.tipoDocumentoTitolare,
        numerodocumentotitolare : postData.numeroDocumentoTitolare,
        sceltaprimoturno : postData.sceltaPrimoTurno,
        sceltasecondoturno : postData.sceltaSecondoTurno,
        prprimoturno : postData.prPrimoTurno,
        prsecondoturno : postData.prSecondoTurno,
        sceltaturnoAA : postData.sceltaTurnoAA,
        datacongedotitolare : postData.dataCongedoTitolare,
        familiari : postData.familiari,
        numeroabbonamenti : postData.numeroAbbonamenti,
        concabina : postData.conCabina
       }, 
    {
        headers: {
            appkey: "AIzaSyCZuz4jVrcc2NCVmLK0O-SdgQi4oa4aVQg"
          }
    })
    .then(response => {
      console.log(response.data);
      callback(response);
    })
    .catch(err => console.log(err))
  };
